import React from 'react';
import UIComponent from 'ui-components/ui-component';
import Image from 'ui-components/image/image';
import Logo from './logo.png';
import Button from 'ui-components/button/button';
export default class header extends UIComponent {
    get className() {
        return "header";
    }
    get isRegisterEvent() {
        return false;
    }
    getChildren() {
        return <React.Fragment>
            <div className="title" key="title">
                <Image extraClass="logo" src={Logo} />
                <span className="title-text">长春中国光学科学技术馆 — 数字科技馆</span>
            </div>
            <Button extraClass="return"
                onClick={() => {
                    location.href = "http://www.ccostm.com/index.shtml";
                }}>返回主页</Button>
        </React.Fragment>
    }
}